module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDU3MDk2YjZjOTRlMzQ5YjU1YTdlMWY1ZTMzMzZlMTYucG5nIjs="